import { createContext, useContext } from "react";
import { LanguageCode } from "types/language";

export const LanguageContext = createContext({
  language: LanguageCode.EN,
  setLanguage: (language: LanguageCode) => {},
});

export const useLanguageContext = () => useContext(LanguageContext);
